import React from 'react';

function Footer() {
    return (
        <footer className="footer-map-mode status-bar">
            {/* STATIC LIVE INDICATOR */}
            <div className="static-live-indicator">
                <i className="fa-solid fa-circle-dot text-danger-pulse"></i>
                <span>SYSTEM LIVE</span>
            </div>

            {/* SCROLLING DATA */}
            <div className="ticker-wrap">
                <div className="ticker-move">
                    <div className="ticker-item">
                        <i className="fa-solid fa-shield-halved"></i> 25,000+ RESPONDERS ACTIVE NATIONWIDE
                    </div>
                    <div className="ticker-item">
                        <i className="fa-solid fa-tower-broadcast"></i> 36 STATES + FCT UNDER ACTIVE MONITORING
                    </div>
                    <div className="ticker-item">
                        <i className="fa-solid fa-database"></i> DATA SOURCE: SETY INTEL, TRUSTED SOURCES, SETY COMMUNITY & NEWS API 
                    </div>
                    {/* Seamless Loop Duplicate */}
                    <div className="ticker-item">
                        <i className="fa-solid fa-shield-halved"></i> 25,000+ RESPONDERS ACTIVE NATIONWIDE
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;